/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProgramReportSearchCriteriaDto { 
    acceptsMediCal?: boolean;
    agencyId?: string;
    agencyStatusType?: ProgramReportSearchCriteriaDto.AgencyStatusTypeEnum;
    isTestAgency?: boolean;
    receivesReferralsStatus?: boolean;
    regionCentral?: boolean;
    regionEast?: boolean;
    regionNorthCoastal?: boolean;
    regionNorthInland?: boolean;
    regionSouth?: boolean;
    serviceType?: string;
    services?: string;
    servicesFor1624?: boolean;
    servicesForAdult?: boolean;
    servicesForFemale?: boolean;
    servicesForJuvenile?: boolean;
    servicesForMale?: boolean;
    sortBy?: string;
    status?: boolean;
    zipCode?: string;
}
export namespace ProgramReportSearchCriteriaDto {
    export const AgencyStatusTypeEnum = {
        Approved: 'Approved',
        BeingReviewed: 'Being Reviewed',
        Denied: 'Denied',
        Inactive: 'Inactive',
        NotSubmitted: 'Not Submitted',
        RenewalAlert: 'Renewal Alert',
        RenewalExpired: 'Renewal Expired',
        RenewalWarning: 'Renewal Warning',
        ResubmissionRequired: 'Resubmission Required',
        ResubmissionRequiredImmediately: 'Resubmission Required Immediately'
    } as const;
    export type AgencyStatusTypeEnum = typeof AgencyStatusTypeEnum[keyof typeof AgencyStatusTypeEnum];
}


